import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Ventas

export async function getVentas() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_VENTAS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getVentasListAdminByIds(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_LIST_ADMIN_BY_IDS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateVenta(payload) {
  return requests
    .put(constants.API_URL_AGGREGATOR, urls.PUT_VENTA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Pedido vacío (sin items) creado desde el listado de ventas; data trae { id } de la venta nueva
export async function crearNuevoPedidoAdmin(payload) {
  const response = await requests.post(
    constants.API_URL_VENTAS,
    urls.POST_CREAR_NUEVO_PEDIDO_ADMIN,
    payload,
  )
  return { ok: response.ok, data: response.ok ? await response.json() : null }
}

export async function insertObservacionSeguimientoVenta(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_OBSERVACION_SEGUIMIENTO_VENTA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertObservacion(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_OBSERVACION_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function modificarObservacion(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.POST_OBSERVACION_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteObservacion(payload) {
  return requests
    .remove(constants.API_URL_VENTAS, `${urls.DELETE_OBSERVACION}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertEstadoBulto(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_ESTADO_BULTO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function modificarEstadobulto(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.POST_ESTADO_BULTO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEstadosBultos() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_ESTADOS_BULTOS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function deleteEstadoBulto(payload) {
  return requests
    .remove(constants.API_URL_VENTAS, `${urls.DELETE_ESTADO_BULTO}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function deleteEstanteria(payload) {
  return requests
    .remove(constants.API_URL_VENTAS, `${urls.DELETE_ESTANTERIA}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getBandejasTodas() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_BANDEJAS_TODAS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function vaciarBandejaTodas(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_ESTADO_BULTO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBandejas() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_BANDEJAS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function terminarBandeja(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_TERMINAR_BANDEJA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBandejaById(id) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_BANDEJAS}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBandejasLog() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_BANDEJAS_LOG).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}
export async function getEstanterias() {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_ESTANTERIAS}/-1`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getEstantesLlenos() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_ESTANTES_LLENOS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function modificarEstanteria(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.POST_ESTANTERIAS_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertObservacionPreparacionVenta(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_OBSERVACION_PREPARACION_VENTA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCodigoBarrasEstanteria() {
  return requests
    .get(constants.API_URL_AGGREGATOR, urls.GET_CODIGO_BARRAS_ESTANTERIA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEstanteriaVenta(id) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_ESTANTERIA_VENTA}/${id}`)
    .then(async response => {
      if (response.status === 204) return { ok: response.ok }

      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentaById(payload) {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_VENTA_BY_ID}/${payload}`)
    .then(async response => {
      if (response.status === 204) return { ok: response.ok, data: null }

      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentaRecogidaById(ventaId) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_VENTA_RECOGIDA_BY_ID}/${ventaId}`)
    .then(async response => {
      if (!response.ok) return { ok: false, data: null }

      return { ok: true, data: await response.json() }
    })
}

export async function setVentaRecogida(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_SET_VENTA_RECOGIDA, payload)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function cambiarEnvioSeur(ventaId) {
  return requests
    .put(constants.API_URL_AGGREGATOR, `${urls.PUT_CAMBIAR_ENVIO_SEUR}/${ventaId}`)
    .then(async response => {
      return { ok: response.ok, data: response.ok ? null : await response.text() }
    })
}

export async function getVentaByIdControlDiseno(payload) {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_VENTA_CONTROLDISENO_BY_ID}/${payload}`)
    .then(async response => {
      if (response.status === 204) return { ok: response.ok, data: null }

      return { ok: response.ok, data: await response.json() }
    })
}


export async function getVentaItemsCarritoAdminByVentaId(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_VENTAITEMS_CARRITO_ADMIN_BY_VENTA_ID}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentaItemsCarritoAdmin(payload) {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_VENTA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilter(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTAS_FILTER_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFromAggregator() {
  return requests.get(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_LIST).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getVentasFilterFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterReviewFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_REVIEW_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasTildarFilterFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_TILDAR_FILTER_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasLadronFilterFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_LADRON_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterMensajerosNuestrosFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_MENSAJEROS_NUESTROS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterGrabadosSinPersoFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_GRABADOS_SIN_PERSO_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterBordadosSinPersoFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_BORDADOS_SIN_PERSO_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterRescateFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_RESCATE_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterPersonalizadosFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_PERSONALIZADOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterPersonalizadosTotalFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_PERSONALIZADOS_TOTAL_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterPersonalizadosPreparadosFromAggregator(payload) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LIST,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterPersonalizadosFabricadosFromAggregator(payload) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LIST,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterEnSobreFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_EN_SOBRE_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterAmazonFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_AMAZON_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterTodosFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_TODOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterNocturnosFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_NOCTURNOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterNuestrosNocturnosFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_NUESTROS_NOCTURNO_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterDiurnosFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_DIURNOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterFigurasLegoFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_FIGURAS_LEGO_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterEcommerceFromAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_ECOMMERCE_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterEcommerceTramoHorarioFromAggregator(payload) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LIST,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterLocalAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_LOCAL_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterDigitalAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_DIGITAL_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterEmpleadosAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_EMPLEADOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterCantidadPersonalizadosAggregator(payload) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTAS_FILTER_CANTIDAD_PERSONALIZADOS_LIST,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterEkomiAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_EKOMI_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterFueraDeEspanaAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_FUERA_DE_ESPANA_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterFueraDeEspanaSeurAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterFueraDeEspanaDhlAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterDhlAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_DHL_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterChocomensajeMasivoAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFilterNocturnosCorreosAggregator(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTAS_FILTER_NOCTURNOS_CORREOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getObservacionesVenta(payload) {
  return requests
    .get(constants.API_URL_VENTAS, urls.GET_OBSERVACIONES_VENTAS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getAllMailObservacionesTemplateVenta(payload) {
  return requests
    .get(constants.API_URL_VENTAS, urls.GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertMailObservaciones(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateMailObservaciones(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteMailObservaciones(payload) {
  return requests
    .remove(
      constants.API_URL_VENTAS,
      `${urls.GET_MAIL_OBSERVACIONES_TEMPLATE_VENTAS_LIST}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function borrarMensajero(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_BORRAR_MENSAJERO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function borrarBandeja(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_BORRAR_BANDEJA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function marcarPagado(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_MARCAR_PAGADO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Asigna el numero de factura si la venta aun no lo tiene. data: { result, numeroFactura, fechaFactura, timestamp, mensaje }
// result: 1 = OK, 2 = la venta no existe, 3 = cancelada y sin factura
export async function asignarNumeroFactura(ventaId) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_ASIGNAR_NUMERO_FACTURA, { ventaId })
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertarNuevaDevolucion(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_INSERTAR_DEVOLUCION_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function anularDevolucion(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_ANULAR_DEVOLUCION_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentaDevoluciones() {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTA_DEVOLUCIONES_AGG)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertarConfirmacionDevolucion(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_VENTA_CONFIRMAR_DEVOLUCIONES_AGG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFormasPago() {
  return requests
    .get(constants.API_URL_LOGISTICA_PEDIDO, urls.GET_FORMAS_PAGO)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function actualizarFormaPagoDevolucion(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_VENTA_ACTUALIZAR_FORMA_PAGO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaLetra(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_SET_VENTA_LETRA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaVip(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_SET_VENTA_VIP_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function repetirPedidoVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_REPETIR_PEDIDO_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cancelarVentas(payload) {
  return requests
    .patch(constants.API_URL_VENTAS, urls.SET_CANCELAR_VENTAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response }
    })
}

export async function establecerRepetidosConfirmados(payload) {
  return requests
    .patch(constants.API_URL_VENTAS, urls.SET_REPETIDOS_CONFIRMADOS_VENTAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response }
    })  
}

// Abono

export async function insertarNuevoAbono(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_INSERTAR_NUEVO_ABONO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteAbonoVenta(payload) {
  return requests
    .remove(constants.API_URL_VENTAS, `${urls.DELETE_ABONO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getAbonosListByVentaId(payload) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_ABONOS_LIST}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function traspasarVenta(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_TRASPASAR_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Cupon

export async function deleteCuponVenta(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.DELETE_CUPON, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCuponesNoUsados(payload) {
  return requests
    .get(constants.API_URL_VENTAS, urls.GET_CUPONES_NO_USADOS_LIST, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function addCupones(payload) {
  return requests.post(constants.API_URL_VENTAS, urls.ADD_CUPONES, payload).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function cancelarVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_CANCELAR_VENTA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cambiarEstadoMensajeria(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_MODIFICAR_ESTADOS_MENSAJERIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Dhl Seur CorreosExpress MrwClick

export async function dhlBuscar(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_DHL_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function dhl(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_DHL_DHL_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateDhls(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_DHL_GUARDAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function mrwClickBuscar(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLICK_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function mrwClickDiurnos(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLICK_DIURNOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function mrwClickNocturnos(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLICK_NOCTURNOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function mrwClickEcommerce(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLICK_ECOMMERCE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function mrwClickEcommerceTh(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLICK_ECOMMERCE_TH, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function mrwClickSobre(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLICK_SOBRES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateMrws(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_MRWCLICK_GUARDAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function nacexBuscar(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_NACEX_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateNacex(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_NACEX_GUARDAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function seurBuscar(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_SEUR_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function seur(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_SEUR_SEUR_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateSeurs(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_SEUR_GUARDAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCorreosExpress(payload) {
  return requests
    .post(constants.API_URL_LOGISTICA_PEDIDO, urls.POST_CORREOS_EXPRESS_GUARDAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function correosExpressBuscar(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_CORREOS_EXPRESS_BUSCAR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function correosExpressEcommerce(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_CORREOS_EXPRESS_ECOMMERCE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function correosExpressEcommerceTramo(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_CORREOS_EXPRESS_ECOMMERCE_TRAMO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function correosExpressSobres(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_CORREOS_EXPRESS_SOBRES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function transmitirDhls(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_DHL_TRANSMITIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function transmitirSeurs(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_SEURS_TRANSMITIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function transmitirCorreosExpress(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_CORREOS_EXPRESS_TRANSMITIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function transmitirMrwsClick(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_MRWCLCIK_TRANSMITIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function transmitirNacex(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_NACEX_TRANSMITIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Ladron

export async function getLadrones() {
  return requests.get(constants.API_URL_VENTAS, urls.GET_LADRONES).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function insertLadron(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_LADRON_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateLadron(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_LADRON_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteLadron(payload) {
  return requests
    .remove(constants.API_URL_VENTAS, `${urls.DELETE_LADRON_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// MailObservacionVenta

export async function enviarMailObservacionVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_ENVIAR_MAIL_OBSERVACION_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// MailVenta

export async function enviarMailVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_ENVIAR_MAIL_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function obtenerPreviewMailVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_OBTENER_PREVIEW_MAIL_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Tildar listo para imprimir

export async function tildaListoParaImprimirVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_TILDA_LISTO_PARA_IMPRIMIR_VENTA, payload)
    .then(async response => {
      const responseData = await response.json()
      const operationResultHeader = response.headers.get('x-operation-result')
      const operationOkHeader = response.headers.get('x-operation-ok')
      const operationMessageHeader = response.headers.get('x-operation-message')

      const operationResult =
        operationResultHeader !== null && operationResultHeader !== undefined
          ? Number(operationResultHeader)
          : responseData?.operationResult ?? responseData?.result
      const hasOperationStatus = operationResult !== undefined && operationResult !== null
      const operationOk =
        response.ok &&
        (operationOkHeader !== null
          ? operationOkHeader.toLowerCase() === 'true'
          : !hasOperationStatus ||
            responseData?.operationOk === true ||
            operationResult === 1)

      return {
        ok: response.ok,
        operationOk,
        operationResult,
        message: operationMessageHeader || responseData?.message || responseData?.errorMessage,
        data: responseData?.venta ?? responseData,
        raw: responseData,
      }
    })
}

// Tildar listo para imprimir masivo

export async function tildaListoParaImprimirMasivoVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_TILDA_LISTO_PARA_IMPRIMIR_MASIVO_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// VentaItems

export async function addItemVenta(payload, requestId) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_ADD_ITEM_VENTA, payload, requestId)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function setVentaItemFaltante(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.SET_VENTAITEM_FALTANTE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaItemPersonalizado(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.SET_VENTAITEM_PERSONALIZADO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaItemSeparado(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.SET_VENTAITEM_SEPARADO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaItemVerificado(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.SET_VENTAITEM_VERIFICADO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaItemsPreparados(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_ITEMS_PREPARADOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaItemImprimir(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.SET_VENTAITEM_IMPRIMIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteVentaItemsById(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.DELETE_VENTAITEM_BY_ID, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertImagenesIncidencia(payload) {
  return requests
    .postForm(constants.API_URL_VENTAS, urls.INSERT_IMAGEN_INCIDENCIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteImagenIncidencia(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.DELETE_IMAGEN_INCIDENCIA, payload)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function insertObservacionPersonalizacion(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.INSERT_OBSERVACION_PERSONALIZACION, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaBandeja(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_BANDEJA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaBandejaMasivo(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_BANDEJA_MASIVO, payload)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function removeVentaEstante(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.REMOVE_VENTA_ESTANTE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCorreosExpress(payload) {
  return requests
    .get(
      constants.API_URL_VENTAS,
      `${urls.GET_CORREOS_EXPRESS}?id=${!payload?.id ? '' : payload.id}&ventaId=${
        !payload?.idVenta ? '' : payload.idVenta
      }`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentaMensajeria(payload) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_VENTA_MENSAJERIA}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setObservacionesBulto(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_OBSERVACIONES_BULTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setBultosCheckBulto(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_BULTOS_CHECK, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setEstadoVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_ESTADO_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setEstadoBultoVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_ESTADO_BULTO_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaFinalizarImprimir(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_FINALIZAR_IMPRIMIR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaFinalizarImprimirMasivo(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_FINALIZAR_IMPRIMIR_MASIVO, payload)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function getOrdenEstanteria(usuarioId) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.ORDEN_ESTANTERIA}/${usuarioId}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setOrdenEstanteria(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.ORDEN_ESTANTERIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEstanteAleatorio(usuarioId) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_ESTANTE_ALEATORIO}/${usuarioId}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEstanteEnUso(payload) {
  return requests
    .get(
      constants.API_URL_VENTAS,
      `${urls.GET_ESTANTE_EN_USO}?estante=${payload.estante}&ventaId=${payload.ventaId}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaEstanteria(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_ESTANTERIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaNoTilde(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_NO_TILDE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setBultoCheck(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_BULTO_CHECK, payload)
    .then(async response => {
      return { ok: response.ok, status: response.status, data: await response.json() }
    })
}

export async function setObservacionCierreVenta(payload) {
  return requests
    .post(constants.API_URL_VENTAS, urls.SET_OBSERVACIONES_CIERRE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasAgrupadas(ventaId) {
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_VENTAS_AGRUPADAS_LIST}?transporta=${ventaId}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setBandejaBloqueada(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_BANDEJA_BLOQUEADA, payload)
    .then(async response => {
      return { response }
    })
}

export async function setBandejaPropuesta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_BANDEJA_PROPUESTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getModificacionesVenta(payload) {
  if (payload.horaDesde) {
    return requests
      .get(
        constants.API_URL_VENTAS,
        `${urls.GET_MODIFICACIONES_VENTA_LIST}?usuario=${payload.usuario}&horaDesde=${payload.horaDesde}`,
      )
      .then(async response => {
        return { ok: response.ok, data: await response.json() }
      })
  }

  return requests
    .get(
      constants.API_URL_VENTAS,
      `${urls.GET_MODIFICACIONES_VENTA_LIST}?usuario=${payload.usuario}&fechaDesde=${payload.fechaDesde}&fechaHasta=${payload.fechaHasta}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getHistoricoNocturnoVenta(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_HISTORICO_NOCTURNO_LIST}?usuarioId=${payload.usuarioId}&fecha=${payload.fecha}&tipo=${payload.tipo}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getHistoricoNocturnoVentaRango(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_HISTORICO_NOCTURNO_RANGO_LIST}?usuarioId=${payload.usuarioId}&tipo=${payload.tipo}&fechaDesde=${payload.fechadesde}&fechaHasta=${payload.fechahasta}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVelocidadUltimaHora() {
  return requests
    .get(constants.API_URL_AGGREGATOR, urls.GET_VELOCIDAD_ULTIMA_HORA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function createSnapshotVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.CREATE_SNAPSHOT, payload)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function createSnapshotDHLVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.CREATE_SNAPSHOT_DHL, payload)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function createSnapshotFueraEspanaVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.CREATE_SNAPSHOT_FUERA_ESPANA, payload)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function createSnapshotCombinadoVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.CREATE_SNAPSHOT_COMBINADO, payload)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function createSnapshotMensajerosNuestrosVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.CREATE_SNAPSHOT_MENSAJEROS_NUESTROS, payload)
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function getReclamacionesMrwVenta(payload) {
  return requests
    .get(
      constants.API_URL_VENTAS,
      `${urls.GET_MRW_RECLAMACIONES_VENTAS}?fechaDesde=${payload.fechaDesde}&fechaHasta=${payload.fechaHasta}&estado=${payload.estado}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getIdDesencriptado(codigo) {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_ID_DESENCRIPTADO}?codigo=${codigo}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getIdVentaByAlbaran(albaran) {
  // Query string y no segmento de ruta: el albaran de Nacex lleva una barra (2831/14204454)
  // y como segmento rompe el enrutado del controlador aunque vaya escapada.
  const response = await requests.get(
    constants.API_URL_VENTAS,
    `${urls.GET_ID_BY_ALBARAN}?albaran=${encodeURIComponent(albaran)}`,
  )

  // El 404 de "no encontrado" no trae cuerpo, asi que parsearlo lanzaba y la llamada terminaba
  // rechazada. Como quien llama no captura, no salia ni el aviso de error: no pasaba nada.
  if (!response.ok) {
    return { ok: false, data: 0 }
  }

  return { ok: true, data: await response.json() }
}

export async function setVistoEnCuenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_VISTO_EN_CUENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setInpostPupId(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_VENTA_INPOST_PUP_ID, payload)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function setRecuperarPedido(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_RECUPERAR_PEDIDO, payload)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function getVentasUsuarios(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_VENTA_USUARIOS}?fechaDesde=${payload.fechaDesde}&fechaHasta=${payload.fechaHasta}&usuarioId=${payload.usuarioId}`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasUsuariosBandeja(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_USUARIOS_VENTA_BANDEJAS}?fechaDesde=${payload.fechaDesde}&fechaHasta=${payload.fechaHasta}&usuarioId=${payload.usuarioId}`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getProductosPreparados(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_USUARIOS_PRODUCTOS_PREPARADOS}?fechaDesde=${payload.fechaDesde}&fechaHasta=${payload.fechaHasta}&usuarioId=${payload.usuarioId}`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getRegistrosPedidos() {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_USUARIOS_REGISTROS_PEDIDOS}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function sendWhatsappVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.SEND_WHATSAPP_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setPrefijoTelefonoWhatsappVenta(payload) {
  return requests
    .patch(constants.API_URL_VENTAS, urls.PATCH_SET_PREFIJO_WHATSAPP, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Payments
export async function getStripePaymentIntent(payload) {
  return requests
    .post(constants.API_URL_PAYMENT, urls.GET_STRIPE_PAYMENT_INTENT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getStripeUrlPayment() {
  return requests
    .get(constants.API_URL_PAYMENT, urls.GET_CONFIG_URL_STRIPE_PAYMENT)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getRedsysUrlPayment() {
  return requests
    .get(constants.API_URL_PAYMENT, urls.GET_CONFIG_URL_REDSYS_PAYMENT)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCecaUrlPayment() {
  return requests
    .get(constants.API_URL_PAYMENT, urls.GET_CONFIG_URL_CECA_PAYMENT)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getPagoAdyen(ventaId) {
  const response = await requests.get(
    constants.API_URL_PAYMENT,
    `${urls.GET_PAGO_ADYEN}?ventaId=${ventaId}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function getHistoricoPagoAdyen(ventaId) {
  const response = await requests.get(
    constants.API_URL_PAYMENT,
    `${urls.GET_HISTORICO_PAGO_ADYEN}/${ventaId}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function getUltimoPagoAdyen(ventaId) {
  const response = await requests.get(
    constants.API_URL_PAYMENT,
    `${urls.GET_ULTIMO_PAGO_ADYEN}/${ventaId}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function refundAdyen(payload) {
  const response = await requests.post(
    constants.API_URL_PAYMENT,
    urls.POST_PAGO_ADYEN_REFUND,
    payload,
  )
  return { ok: response.ok, data: await response.json() }
}

// Reemplazar
export async function getReemplazarTexto(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_REEMPLAZAR_TEXTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.text() }
    })
}

export async function setEstadoVentaMasivo(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_ESTADO_MASIVO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cambiarHorarioMrwMasivo(payload) {
  return requests
    .put(constants.API_URL_AGGREGATOR, urls.PUT_CAMBIAR_HORARIO_MRW_MASIVO_AGREGADOR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setEstadoMensajeriaVentaMasivo(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.PUT_ESTADO_MENSAJERIA_MASIVO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function sendMailsResenaVenta(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.SEND_EMAILS_RESENA_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteTransportistaVentas(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.DELETE_TRANSPORTISTA_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setVentaItemQuantity(payload) {
  return requests
    .patch(constants.API_URL_VENTAS, urls.SET_VENTA_ITEM_QUANTITY, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.text() }
    })
}

export async function setVentaItemsPrecio(payload) {
  return requests
    .patch(constants.API_URL_VENTAS, urls.SET_VENTA_ITEMS_PRECIO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.text() }
    })
}

export async function getPedidosMensajeros(payload, conMensajero) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_PEDIDOS_MENSAJERO_VENTA}?fechaEntrega=${payload.fechaEntrega}&conMensajero=${conMensajero}`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setOrdenMensajeroVentas(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_ORDEN_MENSAJERO_VENTAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setDatosEntregaVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_DATOS_ENTREGA_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setTransportistaVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_TRANSPORTISTA_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteTransportistaVenta(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.DELETE_TRANSPORTISTA_VENTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setMensajeroSeparado(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.SET_MENSAJERO_SEPARADO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasCompracionAnioAnterior(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTA_COMPARACION_ANIO_ANTERIOR, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasListadosFaltantes(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTA_LISTADO_FALTANTES, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getListadoRamosVendidos(filters) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTA_LISTADO_RAMOS_VENDIDOS_AGREGADOR, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getListadoProductoVendidos(filters) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTA_LISTADO_PRODUCTOS_VENDIDOS_AGREGADOR,
      filters,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getListadoProductoVendidosUrl(filters) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTA_LISTADO_PRODUCTOS_VENDIDOS_URL_AGREGADOR,
      filters,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getListadoProductoFabricados(filters) {
  return requests
    .post(
      constants.API_URL_AGGREGATOR,
      urls.GET_VENTA_LISTADO_PRODUCTOS_FABRICADOS_AGREGADOR,
      filters,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentasFacturasSIIConsulta(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTA_FACTURASII_CONSULTA, filters)
    .then(async response => {
      if (!response.ok) return { ok: false, data: null }
      return { ok: true, data: await response.json() }
    })
}

export async function getVentasFacturasSIIFicheroExcel(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTA_FACTURASII_EXCEL, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function getVentasFacturasSIIFicheroExcelAgrupados(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTA_FACTURASII_EXCEL_AGRUPADOS, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function getVentasFacturasSIIFicheroExcelInterAgrupados(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.GET_VENTA_FACTURASII_EXCEL_AGRUPADOS_INTER, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function getVentasFacturasSIIMarcarEnviadaExcel(filters) {
  return requests
    .post(constants.API_URL_VENTAS, urls.POST_VENTA_FACTURASII_MARCAR_ENVIADA_EXCEL, filters)
    .then(async response => {
      return { ok: response.ok, data: await response }
    })
}

// Pedidos masivos
export async function procesarFicheroPedidoMasivo(formdata) {
  return requests
    .postForm(
      constants.API_URL_AGGREGATOR,
      urls.POST_PROCESAR_FICHERO_PEDIDO_MASIVO_AGREGADOR,
      formdata,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updatePedidoMasivoData(payload) {
  return requests
    .put(constants.API_URL_AGGREGATOR, urls.PUT_ACTUALIZAR_LINEA_PEDIDO_MASIVO_AGREGADOR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertarPedidoMasivo(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_CREAR_PEDIDO_MASIVO_AGREGADOR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getVentaPedidoMasivoExcelFile() {
  return requests
    .get(constants.API_URL_VENTAS, urls.GET_VENTA_PEDIDO_MASIVO_EXCEL_FILE)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Control diseño de Mantas
export async function getControlDisenoMantasByVentaId(ventaId) {
  return requests
    .get(constants.API_URL_AGGREGATOR, `${urls.GET_CONTROL_DISENO_MANTAS_BY_VENTAID}/${ventaId}`)
    .then(async response => {
      // Un 404/400 llega sin cuerpo JSON: parsearlo lanzaria y taparia el mensaje de error de la pantalla
      return { ok: response.ok, data: response.ok ? await response.json() : null }
    })
}

export async function setVentaItemsFabricados(payload) {
  return requests
    .put(constants.API_URL_VENTAS, urls.POST_VENTA_SET_ITEM_FABRICADO, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Estantes Incompletos
export async function getEstantesIncompletos(filters) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_VENTA_ESTANTES_INCOMPLETOS_AGREGADOR, filters)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getAmazonFilter(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_FILTER_AMAZON, payload)
    .then(async response => {
      return { ok: response?.ok, data: await response?.json() }
    })
}

export async function getCountVentasByFechaEntregaHorario(fechaDesde, fechaEntrega, horarioId) {
  const params = new URLSearchParams({ fechaEntrega, horarioId })
  if (fechaDesde) params.append('fechaDesde', fechaDesde)
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_COUNT_VENTAS_BY_FECHA_ENTREGA_HORARIO}?${params.toString()}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCantidadPedidosPorHorario(fechaEntrega, horarioIds) {
  const params = new URLSearchParams({ fechaEntrega })
  horarioIds.forEach(id => params.append('horarioIds', id))
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_CANTIDAD_PEDIDOS_POR_HORARIO}?${params.toString()}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCountVentasByFechaMadrid(fechaLimiteDesde, fechaEntrega) {
  const params = new URLSearchParams({ fechaLimiteDesde, fechaEntrega })
  return requests
    .get(constants.API_URL_VENTAS, `${urls.GET_COUNT_VENTAS_BY_FECHA_MADRID}?${params.toString()}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEmpresaEnvioDefaultAmazon() {
  return requests
    .get(constants.API_URL_AGGREGATOR, urls.GET_EMPRESA_ENVIO_DEFAULT_AMAZON)
    .then(async response => {
      return { ok: response?.ok, data: await response?.json() }
    })
}

export async function setAmazonTransmitir(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_TRANSMITIR_AMAZON, payload)
    .then(async response => {
      return { ok: response?.ok, data: await response?.json() }
    })
}
